import { useState } from 'react';
import { api } from '../api';
import { styles, Modal } from './UI';

export default function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next !== confirm) return setError('New passwords do not match.');
    if (next.length < 8) return setError('New password must be at least 8 characters.');
    setBusy(true);
    try {
      await api.changePassword(current, next);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title="Change Password" onClose={onClose}>
      {done ? (
        <>
          <p style={{ color: '#10B981', marginTop: 0 }}>Password updated.</p>
          <button style={styles.btn} onClick={onClose}>Close</button>
        </>
      ) : (
        <form onSubmit={submit}>
          {error && <div style={styles.errorBox}>{error}</div>}
          <div style={{ marginBottom: 12 }}>
            <label style={styles.label}>Current Password</label>
            <input type="password" style={styles.input} value={current} onChange={e => setCurrent(e.target.value)} required autoFocus />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={styles.label}>New Password</label>
            <input type="password" style={styles.input} value={next} onChange={e => setNext(e.target.value)} required minLength={8} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={styles.label}>Confirm New Password</label>
            <input type="password" style={styles.input} value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={8} />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="submit" style={styles.btn} disabled={busy}>{busy ? 'Saving...' : 'Update Password'}</button>
            <button type="button" style={styles.btnSecondary} onClick={onClose}>Cancel</button>
          </div>
        </form>
      )}
    </Modal>
  );
}
